import { DATABASE_KEY, DATABASE_KEY_LOCALE } from 'src/database/constants.ts';
import { fetchDatabase } from 'src/database/fetchDatabase.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { ApolloClient } from '@apollo/client/core';
import { DatabaseClient } from 'src/database/databaseClient.ts';
import { createDatabaseProviderState } from 'src/database/createDatabaseProviderState.ts';
import { buildLoadDatabaseUrl } from 'src/database/buildLoadDatabaseUrl.ts';

export const handleFirstLoad = async (
    offlineDatabase: LocalForage,
    databaseCache: LocalForage,
    userSettings: UserSettings,
    uri: string,
    assetDomain: string,
): Promise<{ apollo: ApolloClient<unknown>; dbClient: DatabaseClient } | false> => {
    const currentRegionLocale = `${userSettings.currentRegion}${userSettings.currentLocale}`;
    const firstLoadRequired = (await offlineDatabase.getItem(DATABASE_KEY_LOCALE)) !== currentRegionLocale ||
    ((await offlineDatabase.getItem(DATABASE_KEY)) === null);
    if (firstLoadRequired) {
        const db = await fetchDatabase(buildLoadDatabaseUrl(uri, userSettings));
        if (db) {
            await offlineDatabase.setItem(DATABASE_KEY, db);
            await offlineDatabase.setItem(DATABASE_KEY_LOCALE, currentRegionLocale);
            return createDatabaseProviderState(
                new Map(),
                databaseCache,
                userSettings,
                uri,
                assetDomain,
            );
        }
        return false;
    }
    return false;
};
